import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import DamageDetectionCreateUpdate, {
  DamageDetectionCreateUpdateHandle,
  DamageDetectionCreateUpdateProps,
} from "./DamageDetectionCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: DamageDetectionCreateUpdateProps;
}

export default function DamageDetectionCreateUpdateModal({
  createUpdateProps,
  ...modalProps
}: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.damageDetectionId });
  const formWrapperRef = useRef<DamageDetectionCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} damage detection
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <DamageDetectionCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
